<template>
  <Button
    v-b-tooltip.hover.html="tooltipText"
    class="with-hover-text notification-button"
    :class="btnClasses"
    @click.prevent.stop="toggleNotification"
    :loading="loader"
    v-if="user && user.id != idToFollow && isFollowed"
  >
    <i class="fa fa-bell-o" aria-hidden="true"></i>
  </Button>
</template>

<script>

import FollowsService from '@/modules/follows/services/follows-service'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'

export default {
  name: 'NotificationButton',
  props: ['idToFollow', 'isToNotify', 'color', 'isFollowed'],
  components: {
    Button
  },
  data () {
    return {
      tooltipText: {
        title: 'Mesmo que você tenha <strong>desativado</strong> a opção de receber notificações de novos posts, você pode marcar/desmarcar para receber apenas notificações individuais de um autor específico.',
        customClass: 'font-size-xSmall'
      },
      loader: false,
      localNotification: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    btnClasses () {
      const array = [
        {
          active: this.localNotification,
          'background-hover-color4': this.localNotification
        }
      ]
      const color = this.color ? this.color : 'btn-outline-color2'
      array.push(color)
      return array
    }
  },
  created () {
    this.localNotification = this.isToNotify
  },
  watch: {
    isToNotify (newValue, oldValue) {
      this.localNotification = newValue
    }
  },
  methods: {
    async toggleNotification () {
      this.loader = true
      try {
        await FollowsService.toggleNotification(this.idToFollow)
        this.localNotification = !this.localNotification
        this.$emit('notification-toggled', this.localNotification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
 .notification-button {
   padding: 0 0 0 1px;
   width: 44px;
   height: 44px;
   line-height: 10px;
 }
</style>
